import * as Yup from 'yup';
export const schema = (questions) => {
  const shape = {};
  questions.forEach((question, index) => {
    if (question.questionType === 'Cuadro de texto de una línea' || question.questionType === 'Cuadro de texto con varias líneas') {
      let questionSchema = Yup.string();
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      if (question.requiredValidInput) {
        questionSchema = questionSchema.test('is-valid', question.validationError, (value) => {         
          if (!value){
            return false;
          }else if (question.min && question.max) {
            return value.length >= question.min && value.length <= question.max;
          } else if (question.min) {
            return value.length >= question.min;
          } else if (question.max) {
            return value.length <= question.max;
          }
          return true;
        });
      }
      shape[`question_${index}`] = questionSchema;
    } else if (question.questionType === 'Opción múltiple: se permiten varias respuestas') {
      let questionSchema = Yup.array().min(1, 'Selecciona al menos una opción');
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      shape[`question_${index}`] = questionSchema;
    }else if (question.questionType === 'Opción múltiple: solo una respuesta') {
      let questionSchema = Yup.string();
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      shape[`question_${index}`] = questionSchema;
    }else if (question.questionType === 'Fecha') {
      let questionSchema = Yup.date();
      if (question.min) {
        questionSchema = questionSchema.min(question.min, question.validationError);
      }
      if (question.max) {
        questionSchema = questionSchema.max(question.max, question.validationError);
      }
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      shape[`question_${index}`] = questionSchema;
    }else if(question.questionType === 'Fecha y hora'){
      let questionSchema = Yup.date();
      if (question.min) {
        questionSchema = questionSchema.min(question.min, question.validationError);
      }
      if (question.max) {
        questionSchema = questionSchema.max(question.max, question.validationError);
      }
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      shape[`question_${index}`] = questionSchema;

    }else if (question.questionType === 'Valor numérico') {
      let questionSchema = Yup.number();
      if (question.min) {
        questionSchema = questionSchema.min(question.min, question.validationError);
      }
      if (question.max) {
        questionSchema = questionSchema.max(question.max, question.validationError);
      }
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      shape[`question_${index}`] = questionSchema;
    } else if (question.questionType === 'Matriz'){
      let questionSchema = Yup.array().of(
        Yup.object().shape({
          value: Yup.string().required('La respuesta es requerida')
        })
      ).min(question.answers.filter(aw => aw.type === 'Fila').length, 'Completa todas las respuestas');
      if (question.isRequiredAnswer) {
        questionSchema = questionSchema.required(question.errorMessage);
      }
      shape[`question_${index}`] = questionSchema;
    }
  });
  return Yup.object().shape(shape);
}